import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./MobileCoverage.css";

const COVERAGE_MAP_URL = "https://mobilemaps.net.au/ui/geomaps/v1/coverage/index.html?mode=wholesale";

export default function MobileCoverage(): JSX.Element {
  const [mapLoaded, setMapLoaded] = useState(false);
  const [mapSlow, setMapSlow] = useState(false);
  const [mapKey, setMapKey] = useState(0);

  useEffect(() => {
    setMapLoaded(false);
    setMapSlow(false);
    const timer = window.setTimeout(() => setMapSlow(true), 7000);
    return () => window.clearTimeout(timer);
  }, [mapKey]);

  return (
    <main className="page mobile-coverage-page">
      <section className="coverage-hero">
        <p className="eyebrow">Mobile Network</p>
        <h1>Coverage and Outages</h1>
        <p>
          The mobile product of Jortel uses the Telstra Wholesale Mobile Network, with predicted coverage areas in all Australian major cities, most outer-metro areas and larger regional centres, as well as many smaller towns and transport corridors. Predicted coverage details are available on this coverage map page.
        </p>
      </section>

      <section className="coverage-actions" aria-label="Mobile outage links">
        <a href="https://www.telstra.com.au/outages" target="_blank" rel="noopener noreferrer">
          Current outages
        </a>
        <a href="https://www.telstra.com.au/outages/outage-register" target="_blank" rel="noopener noreferrer">
          Historical outages register
        </a>
      </section>

      <section className="coverage-map-section">
        <div className="coverage-map-heading">
          <div>
            <p className="eyebrow small">Predicted Coverage</p>
            <h2>Telstra Wholesale Mobile Network Coverage Map</h2>
          </div>
          <Link to="/plans/mobile">View mobile plans</Link>
        </div>

        <div className={`coverage-map-frame ${mapLoaded ? "loaded" : ""}`}>
          {!mapLoaded && (
            <div className="coverage-map-loader" role="status" aria-live="polite">
              <div className="coverage-spinner" aria-hidden="true" />
              <h3>{mapSlow ? "The coverage map is taking longer than usual" : "Loading coverage map"}</h3>
              <p>
                {mapSlow
                  ? "This map is loaded from Telstra Wholesale's external mapping service. You can wait, reload it, or open the map in a new tab."
                  : "This may take a few moments while the external mapping service starts."}
              </p>
              {mapSlow && (
                <div className="coverage-loader-actions">
                  <button type="button" onClick={() => setMapKey((key) => key + 1)}>
                    Reload map
                  </button>
                  <a href={COVERAGE_MAP_URL} target="_blank" rel="noopener noreferrer">
                    Open map in new tab
                  </a>
                </div>
              )}
            </div>
          )}
          <iframe
            key={mapKey}
            width="100%"
            height="800"
            src={COVERAGE_MAP_URL}
            frameBorder="0"
            scrolling="no"
            allow="geolocation"
            title="Telstra Wholesale Mobile Network Coverage Map"
            onLoad={() => setMapLoaded(true)}
          />
        </div>
      </section>
    </main>
  );
}
